import axios, { AxiosResponse } from "axios";
import { ApiError } from "../ApiError";
import apis from "../apis";

export class GetDataEntryApiVersion implements IGetDataEntryApiVersion
{
    public async execute(): Promise<IVersion>
    {
        try
        {
            const response = await axios.get<IVersion>(`${apis.dataEntryApiBaseUrl}v1/Service/version`);
            return response.data;
        }
        catch (response)
        {
            throw ApiError.fromAxiosResponse(response as AxiosResponse);
        }
    }
}

export interface IGetDataEntryApiVersion
{
    execute(): Promise<IVersion>;
}

export interface IVersion
{
    version: string;
}
